exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".es-calendar-week{display:flex;line-height:48px;padding:0 6px}.es-calendar-week__item{flex:1;font-size:14px;text-align:center;font-family:PingFangSC-Regular}.es-calendar-week__holiday{color:#1473ff}", ""]);

// exports
